import { NavLink } from "react-router-dom";
import { useState } from "react";
import { LayoutDashboard, Boxes, MessageSquare, Eye, ImageIcon, Film, Settings, Cpu, Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/models", label: "Modelos", icon: Boxes, testid: "nav-models" },
  { to: "/chat", label: "Chat", icon: MessageSquare, testid: "nav-chat" },
  { to: "/vision", label: "Visión", icon: Eye, testid: "nav-vision" },
  { to: "/image", label: "Imagen", icon: ImageIcon, testid: "nav-image" },
  { to: "/edit", label: "Editar", icon: ImageIcon, testid: "nav-edit" },
  { to: "/video", label: "Vídeo", icon: Film, testid: "nav-video" },
  { to: "/settings", label: "Configuración", icon: Settings, testid: "nav-settings" },
];

function NavItems({ onNavigate }) {
  return (
    <nav className="flex flex-col gap-1 px-3">
      {NAV.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={item.testid}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-sm px-3 py-2 text-sm transition-colors duration-150",
                isActive
                  ? "bg-[#1a1a1a] text-white"
                  : "text-[#a3a3a3] hover:bg-[#121212] hover:text-white"
              )
            }
          >
            <Icon className="h-4 w-4" strokeWidth={1.75} />
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}

export function Layout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#f5f5f5]">
      {/* Sidebar - desktop */}
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-[250px] flex-col border-r border-[#262626] bg-[#0a0a0a] lg:flex">
        <Brand />
        <div className="mt-4 flex-1">
          <NavItems />
        </div>
        <Footer />
      </aside>

      {/* Mobile top bar */}
      <header className="fixed inset-x-0 top-0 z-40 flex h-14 items-center justify-between border-b border-[#262626] bg-[#0a0a0a] px-4 lg:hidden">
        <div className="flex items-center gap-2">
          <Cpu className="h-5 w-5 text-emerald-400" />
          <span className="font-heading text-sm font-bold tracking-tight">KRAI LOCAL AI</span>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="rounded-sm border border-[#262626] p-2 text-[#a3a3a3] hover:text-white"
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </header>

      {/* Mobile drawer */}
      {open && (
        <div className="fixed inset-0 top-14 z-30 bg-[#0a0a0a] lg:hidden">
          <div className="mt-4">
            <NavItems onNavigate={() => setOpen(false)} />
          </div>
          <Footer />
        </div>
      )}

      <main className="pt-14 lg:pl-[250px] lg:pt-0">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">{children}</div>
      </main>
    </div>
  );
}

function Brand() {
  return (
    <div className="flex h-16 items-center gap-2.5 border-b border-[#262626] px-5">
      <div className="flex h-8 w-8 items-center justify-center rounded-sm bg-emerald-500/10 border border-emerald-500/30">
        <Cpu className="h-4.5 w-4.5 text-emerald-400" strokeWidth={2} />
      </div>
      <div className="leading-tight">
        <div className="font-heading text-sm font-bold tracking-tight">KRAI LOCAL AI</div>
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#737373]">Control Panel</div>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div className="border-t border-[#262626] px-5 py-4">
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#737373]">
        Local Engine · llama.cpp
      </div>
      <div className="mt-1 font-mono text-[10px] text-[#525252]">OpenAI-compatible</div>
    </div>
  );
}
